import { provideZoneChangeDetection } from '@angular/core';

import { AppModule } from './app/app.module';
import { SETTINGS_CONFIG, SettingsService } from '@cupoui/core/services/settings.service';
import { KEYCLOAK_CONFIG } from '@cupoui/shared/util/keycloak-runtime-config';
import { platformBrowser } from '@angular/platform-browser';

async function startApp() {
  const settings = await fetch(SettingsService.CONFIG_URL);
  const dynamicConfig = await settings.json();

  await platformBrowser([
    { provide: KEYCLOAK_CONFIG, useValue: dynamicConfig.keycloak },
    { provide: SETTINGS_CONFIG, useValue: dynamicConfig }
  ]).bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()]
  });
}

startApp()
  .then(() => console.debug('Application started'))
  .catch(err => console.error(err));
